import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * 라우트가 바뀌면 문서 맨 위로 되돌린다.
 * 정적 페이지 이동과 같은 감각을 유지하고, 해시가 있으면 그 위치를 존중한다.
 * (html { scroll-behavior: smooth } 때문에 'instant' 를 명시해야 순간 이동한다)
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname, hash]);

  return null;
}
